import React from 'react'
import PropTypes from 'prop-types'
import { useMarketplaceFiltersLogic } from './MarketplaceFilters.logic.js'
import { MarketplaceFiltersView } from './MarketplaceFilters.view.jsx'
import { FilterTriggerButton } from './MarketplaceFilters.styled.js'
import { Icon, Popup } from 'semantic-ui-react'

export const MarketplaceFilters = ({ userRole, tenant, listType }) => {
  const logic = useMarketplaceFiltersLogic({
    userRole,
    tenant,
    listType,
  })

  return (
    <>
      <Popup
        trigger={
          <FilterTriggerButton
            onClick={logic.handleOpen}
            className={logic.filterCount > 0 ? 'has-filters' : ''}
            data-testid='marketplace-filters-toggle-btn'
          >
            <Icon name='filter' />
            {logic.filterCount === 0
              ? 'No Filters Applied'
              : `${logic.filterCount} Filter${logic.filterCount !== 1 ? 's' : ''} Applied`}
          </FilterTriggerButton>
        }
        disabled={logic.filterCount === 0}
        on='hover'
        position='bottom left'
        size='mini'
        content={logic.appliedFiltersWithDisplay.map((f) => (
          <div key={f.key}>
            <strong>{f.name}:</strong> {f.displayValue}
          </div>
        ))}
      />

      {/* Filter Modal */}
      <MarketplaceFiltersView
        isOpen={logic.isOpen}
        handleClose={logic.handleClose}
        availableFilterOptions={logic.availableFilterOptions}
        selectedFilterKey={logic.selectedFilterKey}
        currentFilterDef={logic.currentFilterDef}
        selectedValue={logic.selectedValue}
        handleFilterTypeSelect={logic.handleFilterTypeSelect}
        handleValueChange={logic.handleValueChange}
        appliedFiltersWithDisplay={logic.appliedFiltersWithDisplay}
        handleAddFilter={logic.handleAddFilter}
        handleRemoveFilter={logic.handleRemoveFilter}
        handleClearFilters={logic.handleClearFilters}
        handleApplyFilters={logic.handleApplyFilters}
        isApplying={logic.isApplying}
        isClearing={logic.isClearing}
        isAddDisabled={logic.isAddDisabled}
      />
    </>
  )
}

MarketplaceFilters.propTypes = {
  userRole: PropTypes.oneOf(['admin', 'imc', 'carrier']),
  tenant: PropTypes.object,
  listType: PropTypes.oneOf(['orders', 'trips']),
}

MarketplaceFilters.defaultProps = {
  userRole: 'admin',
  tenant: null,
  listType: 'orders',
}
